// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-edit-container {
    padding: 0 40px 40px;
    background-color: #fff;
}

.customer-edit-container .breadcrumb {
    background-color: #f5f5f5;
    padding: 21px 82px;
    margin: 0 -40px 30px;
    color: #717171;
}

.page-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 30px;
}

.page-title-bar {
    width: 5px;
    height: 24px;
    background-color: #e84118;
}

.page-header h2 {
    font-size: 24px;
    font-weight: bold;
    margin: 0;
}

.form-section {
    margin-bottom: 40px;
}

.section-title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #222;
    padding-bottom: 15px;
    margin-bottom: 0;
}

.section-title-container h3 {
    font-size: 20px;
    font-weight: bold;
    margin: 0;
}

.btn-sm {
    padding: 10px 20px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    font-size: 14px;
}

.btn-dark {
    background-color: #222;
    color: white;
}

.form-table {
    margin-top: 0;
}

.form-row {
    display: flex;
    border-bottom: 1px solid #eee;
    align-items: center;
}

.form-label {
    background-color: #f9f9f9;
    font-weight: bold;
    padding: 20px 30px;
    width: 150px;
    min-width: 150px;
    display: flex;
    align-items: center;
}

.form-row.multi-field-row .form-label {
    align-self: stretch;
}

.form-row .required {
    color: #e84118;
    margin-left: 5px;
}

.form-input-container {
    padding: 15px 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-grow: 1;
    flex-wrap: wrap;
}

.form-input-container input[type="text"],
.form-input-container input[type="email"],
.form-input-container input[type="password"],
.form-input-container select,
.form-input-container textarea {
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 15px;
    flex-grow: 1;
}

.form-input-container .short-input {
    flex-grow: 0;
    width: 250px;
}
.form-input-container .long-input {
    flex-grow: 0;
    width: 432px;
}
.form-input-container .short-select {
    flex-grow: 0;
    width: 287px;
}

.form-input-container select {
    width: auto;
    min-width: 200px;
}

.form-input-container textarea {
    height: 120px;
    width: 960px;
}

.biz-num-inputs {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 10px;
}

.biz-num-inputs input {
    width: 80px !important;
    text-align: center;
    flex-grow: 0;
}
.multi-field-row .form-input-container {
    justify-content: space-between;
}
.form-sub-field {
    display: flex;
    align-items: center;
    gap: 10px;
}
.form-sub-field .form-label {
    background-color: transparent;
    width: auto;
    padding: 0 15px 0 0;
}


.input-hint {
    margin: 0;
    color: #666;
    font-size: 14px;
    width: 100%;
    flex-basis: 100%;
}
.full-width {
    padding-top: 10px;
}

.long-hint {
    white-space: normal;
    width: auto;
    line-height: 1.5;
    color: #222;
    font-size: 13px;
    align-self: center;
    padding: 0 20px;
}

.checkbox-label {
    display: flex;
    align-items: center;
    gap: 5px;
}

.page-actions {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 50px;
    border-top: 1px solid #222;
    padding-top: 40px;
}

.page-actions button {
    width: 350px;
    padding: 15px;
    border-radius: 5px;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.btn-secondary {
    background-color: #222;
    color: white;
    border: none;
}

.btn-primary {
    background-color: #e84118;
    color: white;
    border: none;
}
.form-row.memo-row {
    align-items: stretch;
}
.form-row.memo-row .form-label {
    padding-top: 15px;
    align-items: flex-start;
}

.arrow-icon {
    font-size: 16px;
    font-weight: bold;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .form-label {
        width: 120px;
        min-width: 120px;
        padding: 15px;
    }

    .form-input-container textarea {
        width: 100%;
    }

    .page-actions button {
        width: 250px;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .customer-edit-container {
        padding: 0 20px 20px;
    }
    
    .form-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
        padding: 15px 0;
    }
    
    .form-label {
        width: 100%;
        background: none;
        padding: 0 0 5px 0;
    }
    
    .form-input-container {
        width: 100%;
        padding: 0;
    }

    .form-input-container input[type="text"],
    .form-input-container input[type="email"],
    .form-input-container input[type="password"],
    .form-input-container select,
    .form-input-container textarea,
    .form-input-container .short-input,
    .form-input-container .long-input,
    .form-input-container .short-select {
        width: 100%;
    }
    
    .biz-num-inputs {
        width: 100%;
    }
    .biz-num-inputs input {
        width: 30% !important;
    }

    .multi-field-row .form-input-container,
    .form-sub-field {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
    
    .page-actions {
        flex-direction: column;
    }
    
    .page-actions button {
        width: 100%;
    }
}

/* 배송지 정보 스타일 */
.delivery-addresses-list {
    width: 100%;
}

.delivery-address-item {
    border: 1px solid #eee;
    border-radius: 8px;
    margin-bottom: 20px;
    padding: 20px;
    background-color: #fafafa;
}

.delivery-address-item:last-child {
    margin-bottom: 0;
}

.address-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
}

.address-header h4 {
    margin: 0;
    font-size: 16px;
    font-weight: bold;
    color: #333;
}

.default-badge {
    background-color: #e84118;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: bold;
}

.delivery-address-item .form-row {
    border-bottom: 1px solid #eee;
    margin-bottom: 0;
}

.delivery-address-item .form-row:last-child {
    border-bottom: none;
}

.delivery-address-item .form-label {
    background-color: #f0f0f0;
    width: 120px;
    min-width: 120px;
    padding: 10px 15px;
    font-size: 14px;
}

.delivery-address-item .form-input-container {
    padding: 10px 15px;
}

.delivery-address-item .form-input-container p {
    margin: 0;
    color: #333;
}

.no-data {
    color: #999;
    font-style: italic;
    margin: 0;
}

/* 등급 선택 스타일 */
.short-select {
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 10px 15px;
    font-size: 14px;
    color: #333;
    cursor: pointer;
}

.short-select:focus {
    outline: none;
    border-color: #e84118;
    box-shadow: 0 0 0 2px rgba(232, 65, 24, 0.1);
}

/* 모바일에서 배송지 정보 스타일 */
@media (max-width: 768px) {
    .delivery-address-item {
        padding: 15px;
        margin-bottom: 15px;
    }
    
    .address-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
    }
    
    .delivery-address-item .form-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
        padding: 10px 0;
    }
    
    .delivery-address-item .form-label {
        width: 100%;
        background: none;
        padding: 0 0 5px 0;
        font-weight: bold;
    }
    
    .delivery-address-item .form-input-container {
        width: 100%;
        padding: 0;
    }
} `, "",{"version":3,"sources":["webpack://./src/admin/css/CustomerEditPage.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,eAAe;AACnB;;AAEA;;;;;IAKI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;AACA;IACI,YAAY;IACZ,YAAY;AAChB;AACA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,6BAA6B;IAC7B,WAAW;IACX,mBAAmB;AACvB;;;AAGA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA,+BAA+B;AAC/B;IACI;QACI,YAAY;QACZ,gBAAgB;QAChB,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,oBAAoB;IACxB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,UAAU;IACd;;IAEA;;;;;;;;QAQI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;IACA;QACI,qBAAqB;IACzB;;IAEA;;QAEI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,eAAe;AACf;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;AACb;;AAEA,cAAc;AACd;IACI,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA,qBAAqB;AACrB;IACI;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;QACR,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,UAAU;IACd;AACJ","sourcesContent":[".customer-edit-container {\n    padding: 0 40px 40px;\n    background-color: #fff;\n}\n\n.customer-edit-container .breadcrumb {\n    background-color: #f5f5f5;\n    padding: 21px 82px;\n    margin: 0 -40px 30px;\n    color: #717171;\n}\n\n.page-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 30px;\n}\n\n.page-title-bar {\n    width: 5px;\n    height: 24px;\n    background-color: #e84118;\n}\n\n.page-header h2 {\n    font-size: 24px;\n    font-weight: bold;\n    margin: 0;\n}\n\n.form-section {\n    margin-bottom: 40px;\n}\n\n.section-title-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 2px solid #222;\n    padding-bottom: 15px;\n    margin-bottom: 0;\n}\n\n.section-title-container h3 {\n    font-size: 20px;\n    font-weight: bold;\n    margin: 0;\n}\n\n.btn-sm {\n    padding: 10px 20px;\n    border-radius: 5px;\n    border: none;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.btn-dark {\n    background-color: #222;\n    color: white;\n}\n\n.form-table {\n    margin-top: 0;\n}\n\n.form-row {\n    display: flex;\n    border-bottom: 1px solid #eee;\n    align-items: center;\n}\n\n.form-label {\n    background-color: #f9f9f9;\n    font-weight: bold;\n    padding: 20px 30px;\n    width: 150px;\n    min-width: 150px;\n    display: flex;\n    align-items: center;\n}\n\n.form-row.multi-field-row .form-label {\n    align-self: stretch;\n}\n\n.form-row .required {\n    color: #e84118;\n    margin-left: 5px;\n}\n\n.form-input-container {\n    padding: 15px 20px;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-grow: 1;\n    flex-wrap: wrap;\n}\n\n.form-input-container input[type=\"text\"],\n.form-input-container input[type=\"email\"],\n.form-input-container input[type=\"password\"],\n.form-input-container select,\n.form-input-container textarea {\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    padding: 15px;\n    flex-grow: 1;\n}\n\n.form-input-container .short-input {\n    flex-grow: 0;\n    width: 250px;\n}\n.form-input-container .long-input {\n    flex-grow: 0;\n    width: 432px;\n}\n.form-input-container .short-select {\n    flex-grow: 0;\n    width: 287px;\n}\n\n.form-input-container select {\n    width: auto;\n    min-width: 200px;\n}\n\n.form-input-container textarea {\n    height: 120px;\n    width: 960px;\n}\n\n.biz-num-inputs {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    gap: 10px;\n}\n\n.biz-num-inputs input {\n    width: 80px !important;\n    text-align: center;\n    flex-grow: 0;\n}\n.multi-field-row .form-input-container {\n    justify-content: space-between;\n}\n.form-sub-field {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n.form-sub-field .form-label {\n    background-color: transparent;\n    width: auto;\n    padding: 0 15px 0 0;\n}\n\n\n.input-hint {\n    margin: 0;\n    color: #666;\n    font-size: 14px;\n    width: 100%;\n    flex-basis: 100%;\n}\n.full-width {\n    padding-top: 10px;\n}\n\n.long-hint {\n    white-space: normal;\n    width: auto;\n    line-height: 1.5;\n    color: #222;\n    font-size: 13px;\n    align-self: center;\n    padding: 0 20px;\n}\n\n.checkbox-label {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.page-actions {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 50px;\n    border-top: 1px solid #222;\n    padding-top: 40px;\n}\n\n.page-actions button {\n    width: 350px;\n    padding: 15px;\n    border-radius: 5px;\n    font-size: 18px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n}\n\n.btn-secondary {\n    background-color: #222;\n    color: white;\n    border: none;\n}\n\n.btn-primary {\n    background-color: #e84118;\n    color: white;\n    border: none;\n}\n.form-row.memo-row {\n    align-items: stretch;\n}\n.form-row.memo-row .form-label {\n    padding-top: 15px;\n    align-items: flex-start;\n}\n\n.arrow-icon {\n    font-size: 16px;\n    font-weight: bold;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .form-label {\n        width: 120px;\n        min-width: 120px;\n        padding: 15px;\n    }\n\n    .form-input-container textarea {\n        width: 100%;\n    }\n\n    .page-actions button {\n        width: 250px;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .customer-edit-container {\n        padding: 0 20px 20px;\n    }\n    \n    .form-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 5px;\n        padding: 15px 0;\n    }\n    \n    .form-label {\n        width: 100%;\n        background: none;\n        padding: 0 0 5px 0;\n    }\n    \n    .form-input-container {\n        width: 100%;\n        padding: 0;\n    }\n\n    .form-input-container input[type=\"text\"],\n    .form-input-container input[type=\"email\"],\n    .form-input-container input[type=\"password\"],\n    .form-input-container select,\n    .form-input-container textarea,\n    .form-input-container .short-input,\n    .form-input-container .long-input,\n    .form-input-container .short-select {\n        width: 100%;\n    }\n    \n    .biz-num-inputs {\n        width: 100%;\n    }\n    .biz-num-inputs input {\n        width: 30% !important;\n    }\n\n    .multi-field-row .form-input-container,\n    .form-sub-field {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n    \n    .page-actions {\n        flex-direction: column;\n    }\n    \n    .page-actions button {\n        width: 100%;\n    }\n}\n\n/* 배송지 정보 스타일 */\n.delivery-addresses-list {\n    width: 100%;\n}\n\n.delivery-address-item {\n    border: 1px solid #eee;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    padding: 20px;\n    background-color: #fafafa;\n}\n\n.delivery-address-item:last-child {\n    margin-bottom: 0;\n}\n\n.address-header {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-bottom: 15px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #ddd;\n}\n\n.address-header h4 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: bold;\n    color: #333;\n}\n\n.default-badge {\n    background-color: #e84118;\n    color: white;\n    padding: 4px 8px;\n    border-radius: 4px;\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.delivery-address-item .form-row {\n    border-bottom: 1px solid #eee;\n    margin-bottom: 0;\n}\n\n.delivery-address-item .form-row:last-child {\n    border-bottom: none;\n}\n\n.delivery-address-item .form-label {\n    background-color: #f0f0f0;\n    width: 120px;\n    min-width: 120px;\n    padding: 10px 15px;\n    font-size: 14px;\n}\n\n.delivery-address-item .form-input-container {\n    padding: 10px 15px;\n}\n\n.delivery-address-item .form-input-container p {\n    margin: 0;\n    color: #333;\n}\n\n.no-data {\n    color: #999;\n    font-style: italic;\n    margin: 0;\n}\n\n/* 등급 선택 스타일 */\n.short-select {\n    background-color: white;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    padding: 10px 15px;\n    font-size: 14px;\n    color: #333;\n    cursor: pointer;\n}\n\n.short-select:focus {\n    outline: none;\n    border-color: #e84118;\n    box-shadow: 0 0 0 2px rgba(232, 65, 24, 0.1);\n}\n\n/* 모바일에서 배송지 정보 스타일 */\n@media (max-width: 768px) {\n    .delivery-address-item {\n        padding: 15px;\n        margin-bottom: 15px;\n    }\n    \n    .address-header {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 5px;\n    }\n    \n    .delivery-address-item .form-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 5px;\n        padding: 10px 0;\n    }\n    \n    .delivery-address-item .form-label {\n        width: 100%;\n        background: none;\n        padding: 0 0 5px 0;\n        font-weight: bold;\n    }\n    \n    .delivery-address-item .form-input-container {\n        width: 100%;\n        padding: 0;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
